// extracted by mini-css-extract-plugin
export default {"loads-table-line-load":"LoadComponent_loads-table-line-load__TTa5X","load-component":"LoadComponent_load-component__nfskH"};